import React, { useState, useEffect } from 'react';
import { getMyFees } from '../../api';
import { toast } from 'react-toastify';

const StudentFees = () => {
  const [fees, setFees] = useState([]);

  useEffect(() => { loadFees(); }, []);

  const loadFees = async () => {
    try {
      const res = await getMyFees();
      setFees(res.data);
    } catch (err) {
      toast.error('Error loading fees');
    }
  };

  const totalPaid = fees.filter(f => f.status === 'paid')
    .reduce((sum, f) => sum + parseFloat(f.amount), 0);
  const totalUnpaid = fees.filter(f => f.status === 'unpaid')
    .reduce((sum, f) => sum + parseFloat(f.amount), 0);

  return (
    <div>
      <h3 style={styles.title}>💰 My Fees</h3>

      <div style={styles.summaryGrid}>
        <div style={{...styles.summaryCard, borderTop: '4px solid #28a745'}}>
          <h2 style={{...styles.amount, color: '#155724'}}>
            Rs. {totalPaid.toLocaleString()}
          </h2>
          <p style={styles.summaryLabel}>Total Paid</p>
        </div>
        <div style={{...styles.summaryCard, borderTop: '4px solid #dc3545'}}>
          <h2 style={{...styles.amount, color: '#721c24'}}>
            Rs. {totalUnpaid.toLocaleString()}
          </h2>
          <p style={styles.summaryLabel}>Total Unpaid</p>
        </div>
        <div style={{...styles.summaryCard, borderTop: '4px solid #0d6efd'}}>
          <h2 style={{...styles.amount, color: '#004085'}}>
            Rs. {(totalPaid + totalUnpaid).toLocaleString()}
          </h2>
          <p style={styles.summaryLabel}>Total Amount</p>
        </div>
      </div>

      <div style={styles.tableCard}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeader}>
              <th style={styles.th}>Fee Type</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Month</th>
              <th style={styles.th}>Year</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Paid Date</th>
            </tr>
          </thead>
          <tbody>
            {fees.length === 0 && (
              <tr>
                <td colSpan="6" style={styles.empty}>No fee records!</td>
              </tr>
            )}
            {fees.map(f => (
              <tr key={f.id} style={styles.tableRow}>
                <td style={styles.td}>{f.fee_type || '-'}</td>
                <td style={styles.td}>
                  <strong>Rs. {parseFloat(f.amount).toLocaleString()}</strong>
                </td>
                <td style={styles.td}>{f.month || '-'}</td>
                <td style={styles.td}>{f.year || '-'}</td>
                <td style={styles.td}>
                  <span style={{
                    ...styles.statusBadge,
                    background: f.status === 'paid' ? '#d4edda' :
                      f.status === 'unpaid' ? '#f8d7da' : '#fff3cd',
                    color: f.status === 'paid' ? '#155724' :
                      f.status === 'unpaid' ? '#721c24' : '#856404'
                  }}>
                    {f.status === 'paid' ? '✅ Paid' :
                      f.status === 'unpaid' ? '❌ Unpaid' : '⚠️ Partial'}
                  </span>
                </td>
                <td style={styles.td}>
                  {f.paid_date
                    ? new Date(f.paid_date).toLocaleDateString()
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', marginBottom: '20px' },
  summaryCard: { background: 'white', borderRadius: '12px', padding: '20px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  amount: { margin: '0 0 5px', fontSize: '24px' },
  summaryLabel: { color: '#666', fontSize: '13px', margin: 0 },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a3a5c' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
  empty: { textAlign: 'center', color: '#999', padding: '40px' },
  statusBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
};

export default StudentFees;